import React, { useState, useEffect } from 'react';
import _, { get } from 'lodash';
import { message } from 'antd';
import { Layout, Sidebar } from '../Common/Component';
import CommercialSidebar from '../commercial/Component/Sidebar';
import eye from '../../Assets/images/eye.svg';
import eyeoff from '../../Assets/images/eye-off.svg';

function Registration(props) {
  const email = JSON.parse(sessionStorage.getItem('email'));
  const commercialData = !_.isEmpty(props?.quote) ? props.quote : JSON.parse(sessionStorage.getItem('commercialData')) || {};
  // const showCommercialSidebar = !_.isEmpty(commercialData) || false;
  const orderSubmit = props.orderSubmit && Object.keys(props.orderSubmit).length ? props.orderSubmit : JSON.parse(sessionStorage.getItem('orderSubmit'));
  const pricingCalc = props.pricingCalc && Object.keys(props.pricingCalc).length ? props.orderSubmit : JSON.parse(sessionStorage.getItem('couponInfoNeededFromPricingCalc'));

  const [password, setPassword] = useState('')
  const [is_footer, setFooter] = useState(false);
  const [confirmation, setConfirmation] = useState('')
  const [passwordIsVisible, togglePassword] = useState(false)
  const [confirmationIsVisible, toggleConfirmation] = useState(false)
  const [showCommercialSidebar, setShowCommercialSidebar] = useState(!_.isEmpty(commercialData) || false);
  const [loader, setLoader] = useState(false);

  const checkLength = (password) => password.length >= 8;
  const containsUppercase = (password) => (/[A-Z]/).test(password);
  const containsNumber = (password) => (/\d/).test(password);
  const isValidPassword = (password) => checkLength(password) && containsUppercase(password) && containsNumber(password);
  const passwordsMatch = (password, confirmation) => JSON.stringify(password) === JSON.stringify(confirmation);
  const isDisabled = () => {
    return (!isValidPassword(password) || !passwordsMatch(password, confirmation))
  };

  useEffect(() => {
    if (!get(props, 'location.state.allowRegistration', false)) {
      window.location.assign('/');
    }

    if (Object.keys(props.Login.data).length > 0) {
      //
      window.location.assign('/account')
    }
    if (Object.keys(props.Login.errors).length > 0) {
      // display error message
      message.error(props?.Login?.errors?.non_field_errors, 10)
    }

    if (props.user.key) {
      showCommercialSidebar && sessionStorage.removeItem('commercialData');
      props.history.push('/login');
      localStorage.clear();
      sessionStorage.clear();
    }

    setTimeout(() => {
      updateDimensions();
      window.addEventListener("resize", updateDimensions());
    }, 500);


    if (Object.keys(props.ResRegister.data).length > 0 && 
      props.ResRegister.message === 'lead-updated') {
      message.success('Data was saved successfully');

      // After create account password
      props.updateCustomerLastCompletedStep({
        step: 6,
        tracking_uuid: JSON.parse(sessionStorage.getItem("tracking_uuid"))
      });

      props.cleanResLeadResponse();
    }

    if (Object.keys(props.ResRegister.data).length > 0 && 
      props.ResRegister.message === 'residential-registered')
    {
      message.success('Registered Successfully');
      props.history.push('/login')
      props.loginUser({ email, password, is_crm: false });
      localStorage.clear();
      sessionStorage.clear();
    }
  })

  // Calculate dimensions
  const updateDimensions = () => {
    if (window.innerWidth <= 500) {
      setFooter(true);
      // setShowCommercialSummary(!isBtnClicked);
    }
    else {
      setFooter(false)
      // setShowCommercialSummary(false);
      setShowCommercialSidebar(!_.isEmpty(commercialData) || false);
    }
  }

  const displayErrors = () => {
    if (!passwordsMatch(password, confirmation)) return "Your passwords need to match";
    if (props.error) {
      if (props.error.email) return props.error.email[0];
      if (props.error.password1) return props.error.password1;
      if (props.error.password2) return props.error.password2;

      return "Invalid Request";
    }
    if (props.ResRegister.errors) {
      if (props.ResRegister.errors.new_password2) return props.ResRegister.errors.new_password2;
    }
  }

  const onRegister = () => {
    setLoader(true);

    if (showCommercialSidebar) {
      props.registerUser({ email, password1: password, password2: confirmation, role: ['commercial_lead'] });
    }
    else {
      props.ResidentialRegister({ email, new_password1: password, new_password2: confirmation, role: ['customer'] })
    }
    setTimeout(() => setLoader(false), 1000);

  }

  if (!get(props, 'location.state.allowRegistration', false)) {
    return <div />
  }

  return (
    <Layout noFooter={showCommercialSidebar && is_footer}>
      <div className="page_inner_content">
        <div className="container">
          <div className='registration'>
            <div className="row justify-content-end ">
              <div className="padding col-md-6 col-lg-5 col-xl-4 col-sm-12 regi-left">
                {
                  showCommercialSidebar ?
                    <div>
                      <h2 className="primary mb-10 mt-3">Thank You!</h2>
                      <p className="primary mb-30">Your commercial service consultant will be in touch within 24 business hours. Feel free to contact us at 1-800-366-3922, or <a href="https://www.doodycalls.com/contact-us/" target="_blank" rel="noopener noreferrer">chat with us</a> if you have any additional questions.</p>

                      <h3 className="primary mb-10">Track your request</h3>
                      <h5 className="primary mb-20">Create a password to track the status of your request!</h5>
                    </div> :
                    <div>
                      <div className="text-one">Register your DoodyCalls online account</div>
                      <div className="text-two">To help you manage your service online, please create a password. We’ll save this information so you can log in with your email address and password.</div>
                    </div>
                }
                <div className="input-text">
                  <input
                    type={passwordIsVisible ? 'text' : 'password'}
                    placeholder='Choose Password'
                    name='password'
                    aria-label="password"
                    id='password'
                    onChange={e => setPassword(e.target.value)}
                  />
                  <span className="eye-icon">
                    {passwordIsVisible
                      ? <img src={eyeoff} alt="" onClick={() => togglePassword(!passwordIsVisible)} />
                      : <img src={eye} alt="" onClick={() => togglePassword(!passwordIsVisible)} />}
                  </span>
                </div>
                <div className="guidelines top-margin"><div className="box" style={checkLength(password) ? { backgroundColor: '#26B70E' } : { backgroundColor: '#B70E0E' }}></div>Passwords must be 8 or more characters in length</div>
                <div className="guidelines"><div className="box" style={containsUppercase(password) ? { backgroundColor: '#26B70E' } : { backgroundColor: '#B70E0E' }}></div>Passwords must contain 1 or more uppercase characters</div>
                <div className="guidelines"><div className="box" style={containsNumber(password) ? { backgroundColor: '#26B70E' } : { backgroundColor: '#B70E0E' }}></div>Passwords must contain 1 or more numbers</div>
                <div style={{ height: 80, display: 'flex', marginBottom: 20, flexDirection: 'column', justifyContent: 'flex-end' }}>
                  <div className="err_msg mt-20">{displayErrors()}</div>
                  <div className="input-text">
                    <input
                      type={confirmationIsVisible ? 'text' : 'password'}
                      placeholder='Confirm Password'
                      aria-label="confirmation"
                      name='confirmation'
                      id='confirmation'
                      onChange={e => setConfirmation(e.target.value)}
                    />
                    <span className="eye-icon">
                      {confirmationIsVisible
                        ? <img src={eyeoff} alt="" onClick={() => toggleConfirmation(!confirmationIsVisible)} />
                        : <img src={eye} alt="" onClick={() => toggleConfirmation(!confirmationIsVisible)} />}
                    </span>
                  </div>
                </div>
                <div className="disclaimer">By creating an account, I agree to DoodyCalls Terms and Privacy Policy. By providing my email, I agree to receive emails from DoodyCalls, including for marketing purposes. I may opt out of these emails by following the unsubscribe link provided in them.</div>
                <div className='submit_btn'>
                  <button
                    type='button'
                    aria-label="submit-button"
                    disabled={isDisabled()}
                    onClick={() => onRegister()}
                    className='btn'
                  >
                    Register my account
                  </button>
                </div>
              </div>

              <div className={is_footer ? 'col-md-6 col-lg-5 col-xl-4' : 'col-md-6 col-lg-5 col-xl-4'}>
                {showCommercialSidebar ?
                  !is_footer &&
                  <CommercialSidebar
                    history={props.history}
                    commercialData={commercialData}
                    is_footer={is_footer}
                  /> :
                  <Sidebar
                    service_order_data={orderSubmit}
                    pricingCalc={pricingCalc}
                    is_footer={is_footer}
                  />
                }
                {(showCommercialSidebar || is_footer) && <div className="sidebar_note"><p>Questions about your quote? Call us at <a href="/#" >1-800-366-3922</a> and we’ll walk you through it. We’re available Mon-Fri from 8AM to 9PM. Or <a href="/#">email</a> us any time!</p></div>}
              </div>
            </div>
          </div>
        </div>
        {loader && <div className="loader_wrapper">
          <div className="loader07"></div>
        </div>}
      </div>
    </Layout>)
}

export default Registration;
